import {
  GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST,
  GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS,
  GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE,
  GET_SINGLE_DOWNLOAD_REQUEST,
  GET_SINGLE_DOWNLOAD_SUCCESS,
  GET_SINGLE_DOWNLOAD_FAILURE,
} from "./documentDownloadCenterTypes";

const initialState = {
  loading: false,
  documentDownloadCenter: [],
  error: "",
};

const getDocumentDownloadCenterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS:
      return {
        loading: false,
        documentDownloadCenter: action.payload,
        error: "",
      };
    case GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE:
      return {
        loading: false,
        documentDownloadCenter: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateForSingleDownload = {
  loading: false,
  singleDownload: [],
  error: "",
};

const getSingleDownloadReducer = (
  state = initialStateForSingleDownload,
  action
) => {
  switch (action.type) {
    case GET_SINGLE_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        singleDownload: action.payload,
        error: "",
      };
    case GET_SINGLE_DOWNLOAD_FAILURE:
      return {
        loading: false,
        singleDownload: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
export { getDocumentDownloadCenterReducer, getSingleDownloadReducer };
